import Icon from 'veui/components/Icon'
import { IconEyeSlash } from 'dls-icons-vue'

Icon.register('eye-slash', IconEyeSlash)
